import { CellContext } from '@tanstack/react-table';
import { DropdownOptionDto } from '@/features/dashboard/tourCustomFields/types/DropdownCustomFieldDefinitionDto.ts';
import { EmptyValue } from '@/components/ui/EmptyValue.tsx';
import { CellChipList } from '@/components/table/_fieldDefinitions/_base/CellChipList.tsx';

/**
 * Wybór wielokrotny przychodzi jako tablica identyfikatorów. Wcześniej render
 * rzutował ją na string i szukał opcji po całej tablicy, więc komórka
 * pokazywała sklejone id zamiast etykiet.
 */
export const multiselectFieldRender = <T,>(
  info: CellContext<T, unknown>,
  customFieldsContext?: { options: DropdownOptionDto[] },
) => {
  const value = info.getValue();
  const optionIds = Array.isArray(value)
    ? (value as string[])
    : [value].filter((id): id is string => typeof id === 'string' && id !== '');

  if (optionIds.length === 0) return <EmptyValue />;

  const options = customFieldsContext?.options ?? [];
  return (
    <CellChipList
      items={optionIds.map((id) => ({
        key: id,
        label: options.find((opt) => opt.id === id)?.label ?? id,
      }))}
    />
  );
};
